import React, { useState, useEffect } from 'react';

import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';
import Autocomplete from '@material-ui/lab/Autocomplete';
import moment from 'moment';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import { WithApp } from 'contexts/appContext';
import { ImportExcel } from 'components/Tvendo/Common/ImportExcel';
import { wsGetAll, wsFindBy } from 'services/WService.js';

export default WithApp(function ModalCuotaProvider(props) {
  const cuota = props.model;
  const customerPortfolioB = props.model;

  const [dataImport, setDataImport] = useState({});
  const [BusinessPartner, setBusinessPartner] = useState([]);
  const [Mark, setMark] = useState([]);
  const [Zone, setZone] = useState([]);
  const [Supervisor, setSupervisor] = useState([]);

  const [openModalBPartner, setOpenModalBPartner] = useState(false); //Abrir modal
  const [bPartnerSelect, setBPartnerSelect] = useState(undefined);
  const [dataChanging, setDataChanging] = useState(customerPortfolioB);


  function handleChange(field, value) {
    setDataChanging(prev => ({ ...prev, [field]: value }));
  }

  async function listBasePartners() {
    let response = await wsFindBy('base/business-partner', { CardType: 'S', QryGroup1: 'Y' });
    if (response.success) setBusinessPartner(response.data);
  }
  async function listMarks() {
    let response = await wsFindBy('logi/mark', { state: 'A', deleted: null });
    if (response.success) setMark(response.data);
  }
  async function listZones() {
    let response = await wsFindBy('base/zone', { state: 'A', deleted: null });
    if (response.success) setZone(response.data);
  }
  async function listSupervisores() {
    let response = await wsFindBy('base/supervisor', { state: 'A', deleted: null });
    if (response.success) setSupervisor(response.data);
  }

  useEffect(() => {
    if (cuota.open) setBPartnerSelect(undefined);
  }, [cuota.open]);

  useEffect(() => {
    if (dataImport?.success) {
      console.log("Importación exitosa", dataImport);
  
      setDataChanging((prev) => ({
        ...prev,
        base_business_partner_id: null,
        CardCode: '',
      }));
  
      setBPartnerSelect({
        success: dataImport.success,
        customers: dataImport.data.map((item) => {
          return {
            CardCode : item.SOCIONEGOCIO,
            mark_code: item.MARCA || null,
            zone_code : item.ZONA.toUpperCase(),
            tipo: item.TIPO.toUpperCase(),
            peso: item.PESO,
            importe_comision: item.IMPORTE,
          };
        }),
        // SlpName: dataImport.nameFile,
      });
    } else if (dataImport?.success === false) {
      console.log("Importación fallida", dataImport);
      setBPartnerSelect(undefined);
    }
  }, [dataImport]);

  useEffect(() => {
    if (bPartnerSelect?.base_business_partner_id) {
      setDataChanging((prev) => ({
        ...prev,
        base_business_partner_id: bPartnerSelect?.base_business_partner_id || null,
        CardCode: bPartnerSelect?.CardCode || '',
      }));
    }
  }, [bPartnerSelect]);

  
  useEffect(() => {
      if (customerPortfolioB.open) {
      if (!customerPortfolioB.id) listBasePartners(); listMarks(); listZones();listSupervisores();
      setDataChanging(customerPortfolioB);
      }
  }, [customerPortfolioB.open]);

  return (
    <>
      <Modal
        title={`Nuevo registro de comisiones`}
        model={{ open: cuota.open }}
        setOpen={props.setOpen}
        showNotify={props.showNotify}
        reload={props.reload}
        arrDataResponse
        entity={
          dataChanging.CardCode
            ? 'sale/comisiones'
            : 'sale/comisiones/multiple'
        }
        dataForce={
          dataChanging.CardCode
            ? {
                base_business_partner_id: dataChanging.base_business_partner_id,
                CardCode: dataChanging.CardCode,
                logi_mark_id: dataChanging.logi_mark_id,
                mark_code: dataChanging.mark_code,
                base_zone_id: dataChanging.base_zone_id,
                zone_code: dataChanging.zone_code,
                base_supervisor_id: dataChanging.base_supervisor_id,
              }
            : {
                CardCode: cuota.valueSearch?.CardCode,
                customers: bPartnerSelect?.customers,
                force: 'N'
              }
        }
      >
        <TextField
          label="Periodo"
          fullWidth
          type="month"
          name="Periodo"
          margin="normal"
          defaultValue={moment(cuota.valueSearch?.Periodo).format('YYYY-MM') || ''}
          InputLabelProps={{ shrink: true }}
          inputProps={{ readOnly: true }}
          required
        />
        <span style={{ display: 'flex', alignItems: 'flex-end' }}>
          <Autocomplete
              disableClearable
              options={BusinessPartner}
              getOptionLabel={(item) => `${item.CardName} - Código: ${item.CardCode}`}
              renderInput={(params) => (
                  <TextField {...params} label="Socios de negocio" margin="normal" fullWidth />
              )}
              onChange={(e, item) => {handleChange('base_business_partner_id', item?.id);handleChange('CardCode', item?.CardCode  || null); setDataImport(null);}}
              value={BusinessPartner.find((business) => business.id === dataChanging.base_business_partner_id && business.CardCode  === dataChanging.CardCode ) || null}
              style={{ flexGrow: 1, marginRight: '10px' }}
          />
          <ImportExcel
            setDataImport={setDataImport}
            btnColor="success"
            validDuplicate="SOCIONEGOCIO"
            sortDuplicate="SOCIONEGOCIO"
            downTemplate={{
                fileNameDown: `${moment(cuota?.valueSearch?.Periodo).format('YYYY-MM')}_Plantilla de comisiones`,
                fields: ['SOCIONEGOCIO','MARCA','ZONA','TIPO','PESO','IMPORTE']
            }} 
          />
        </span>
        {dataImport?.success && (
          <p style={{ color: '#07c107', marginTop: '10px', fontSize: '14px' }}>
            Archivo importado: {dataImport.nameFile}
          </p>
        )}
        {dataChanging.CardCode ? (
          <>
            <Autocomplete
                disableClearable
                options={Mark}
                getOptionLabel={(item) => `${item.description} - Código: ${item.code}`}
                renderInput={(params) => (
                    <TextField {...params} label="Marcas" margin="normal" fullWidth />
                )}
                onChange={(e, item) => {handleChange('logi_mark_id', item?.id);handleChange('mark_code', item?.code  || null); setDataImport(null);}}
                value={Mark.find((mark) => mark.id === dataChanging.logi_mark_id && mark.code  === dataChanging.mark_code ) || null}
                style={{ flexGrow: 1, marginRight: '10px' }}
            />
            <Autocomplete
                disableClearable
                options={Zone}
                getOptionLabel={(item) => `${item.description} - Código: ${item.code}`}
                renderInput={(params) => (
                    <TextField {...params} label="Zonas" margin="normal" fullWidth />
                )}
                onChange={(e, item) => {handleChange('base_zone_id', item?.id);handleChange('zone_code', item?.code  || null); setDataImport(null);}}
                value={Zone.find((zone) => zone.id === dataChanging.base_zone_id && zone.code  === dataChanging.zone_code ) || null}
                style={{ flexGrow: 1, marginRight: '10px' }}
                required
            />
            <Autocomplete
              disableClearable
              options={Supervisor}
              getOptionLabel={(item) => `${item.name}`}
              renderInput={(params) => (
                <TextField {...params} label="Supervisores" margin="normal" fullWidth />
              )}
              onChange={(e, item) => {handleChange('base_supervisor_id', item?.id); setDataImport(null);}}
              value={Supervisor.find((supervisor) => supervisor.id === dataChanging.base_supervisor_id) || null}
              style={{ flexGrow: 1, marginRight: '10px' }}
            />
            <FormControl fullWidth margin="normal" size="small">
              <InputLabel>Tipo</InputLabel>
              <Select
                required
                value={dataChanging.tipo || ''}
                inputProps={{
                  name: 'tipo',
                  onChange: (e) => handleChange('tipo', e.target.value),  
                }}
              >
                <MenuItem value="PD">Proveedores en desarrollo</MenuItem>
                <MenuItem value="PP">Proveedores principales</MenuItem>
              </Select>
            </FormControl>
            <TextField
              label="Peso"
              fullWidth
              type="number"
              name="peso"
              margin="normal"
              value={dataChanging.peso || ''}
              onChange={(e) => handleChange('peso', e.target.value)}
              required
            />
            <TextField
              label="Importe de comisión"
              fullWidth
              type="number"
              name="importe_comision"
              margin="normal"
              value={dataChanging.importe_comision || ''}
              onChange={(e) => handleChange('importe_comision', e.target.value)}
              required
            />
          </>
        ) : undefined}
      </Modal>
    </>
  );
});
